module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('p', {
    staticClass: "Ahead"
  }, [_c('span', {
    staticClass: "com-rorohiko-pagestaker-style"
  }, [_vm._v("iv")])]), _vm._v(" "), _c('p', {
    staticClass: "_about",
    attrs: {
      "id": "_idParaDest-1"
    }
  }, [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticClass: "tx-ni"
  }, [_vm._v("Michelle Welch is the owner of the SoulTopia, LLC chain of metaphysical stores, where she offers a variety of services as a psychic medium. She is a licensed attorney and has lent her intuitive abilities to notable court cases. Michelle is the host of the "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("SoulWhat")]), _vm._v(" podcast and the Michelle SoulTopia YouTube channel. As the owner of the Northwest Tarot Symposium and The International Divination Event, she has also presented at many other events, including the Reader’s Studio and the International New Age Trade Show. As seen on "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("CBS News")]), _vm._v(", "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Inside Edition")]), _vm._v(", "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Jenny McCarthy Show")]), _vm._v(", "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Coast to Coast")]), _vm._v(", "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Morning After")]), _vm._v(", "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("Good Morning Texas")]), _vm._v(", and much more. Michelle is the author of "), _c('span', {
    staticClass: "ital"
  }, [_vm._v("The Magic of Connection")]), _vm._v(" published by Llewelyn Worldwide. Visit her at MichelleWelch.com and MySoulTopia.com.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8c95992a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 57
// module chunks = 0